<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="reporter-list-view" class="data-list-container cms-member-list">
    <feather-icon class="sm:inline-flex xl:hidden cursor-pointer" icon="MenuIcon" style="height: 20px; margin-right: 10px;" @click.stop="showSidebar"></feather-icon>
    <vs-table ref="table" pagination search :max-items="renderMethod.itemsPerPage" :data="users">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- <div id="data-list-search-rank" style="width: 80px; height: 40px; padding-top: 0;">
          <vs-dropdown class="flex flex-wrap-reverse">
            <a class="flex items-center" href="#">
              <span class="mr-2">{{ factorToText(renderMethod.factor) }}</span>
              <i class="material-icons">expand_more</i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="renderMethod.factor='name'">이름</vs-dropdown-item>
              <vs-dropdown-item @click="renderMethod.factor='account_id'">아이디</vs-dropdown-item>
              <vs-dropdown-item @click="renderMethod.factor='email'">이메일</vs-dropdown-item>
              <vs-dropdown-item @click="renderMethod.factor='level'">권한</vs-dropdown-item>
              <vs-dropdown-item @click="renderMethod.factor='hp'">전화</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div style="margin-bottom:15px; padding-top: 0;">
          <vs-input v-on:keyup.enter="searchUserList()"  class="inputx" placeholder="검색" v-model="renderMethod.inputText"/>
        </div>
        <div class="vs-table--search" style="margin: 0px 15px">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            color="primary"
            type="border"
            class="p-2 cursor-pointer vs-con-loading__container"
            @click="searchUserList()"
          >검색</vs-button>
        </div> -->
        <div class="vs-table--search" style="margin: 5px 15px 5px 0px">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            color="primary"
            type="border"
            class="p-2 cursor-pointer vs-con-loading__container"
            @click="createUserModalActive = true"
          >추가</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ ((currentx - 1) * renderMethod.itemsPerPage) + 1 }} - {{ numOfUsers >= renderMethod.itemsPerPage ? (currentx * renderMethod.itemsPerPage) : numOfUsers }} of {{ numOfUsers }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeItemPerPage(4)">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemPerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemPerPage(15)">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemPerPage(20)">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">아이디</vs-th>
        <vs-th sort-key="name">이름</vs-th>
        <vs-th sort-key="email">이메일</vs-th>
        <vs-th sort-key="level">권한</vs-th>
        <vs-th sort-key="delFrag">승인</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><div v-on:click="showUserInfo(tr.id)" class="cms-cell-link">{{ tr.id }}</div></vs-td>
            <vs-td v-if="[33263, 33264, 33265, 33266, 33267, 33218, 33316, 33427, 33428].find(e => e == tr.idx)"><div style="color: blue;">{{ tr.name }}</div></vs-td>
            <vs-td v-else><div>{{ tr.name }}</div></vs-td>
            <vs-td><div>{{ tr.email }}</div></vs-td>
            <vs-td><div>{{ tr.levelText }}</div></vs-td>
            <vs-td><div>{{ tr.delFrag }}</div></vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- <div>
      <vs-pagination :total="numOfPages" v-model="currentx"></vs-pagination>
    </div> -->

    <!-- Start: 계정 생성/수정 팝업 -->
    <!-- 생성과 수정은 입력 항목이 같다. 팝업 하나를 userModalMode 로 나눠 쓴다.
         바인딩은 computed userForm 이 모드에 맞는 데이터 객체를 돌려준다. -->
    <vs-popup classContent="popup-example"
              :title="userModalMode === 'edit' ? '계정 수정' : '계정 생성'"
              :active.sync="userModalActive">
      <div :class="userModalMode === 'edit' ? 'edit-user-form' : 'create-user-form'">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>이름</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <vs-input :success="regExpName.test(userForm.name)"
                      :danger="!regExpName.test(userForm.name)"
                      danger-text="완전한한글, 영문, 숫자, _로 2~20글자 입력해야 하며, 특수문자를 입력할 수 없습니다."
                      class="w-full" v-model="userForm.name"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>아이디</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <vs-input :success="regExpAccountId.test(userForm.account_id)"
                      :danger="!regExpAccountId.test(userForm.account_id)"
                      danger-text="아이디는 6~12글자, 공백 및 특수문자를 포함할 수 없습니다."
                      class="w-full" v-model="userForm.account_id"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>비밀번호</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <!-- 생성은 필수(danger), 수정은 비워두면 변경 안 함(warning) -->
            <vs-input :success="regExpPassword.test(userForm.password)"
                      :danger="userModalMode !== 'edit' && !regExpPassword.test(userForm.password)"
                      :warning="userModalMode === 'edit' && !regExpPassword.test(userForm.password)"
                      danger-text="비밀번호는 8~15개의 영문 대소문자, 1개 이상의 특수문자를 반드시 포함해야 합니다."
                      warning-text="비밀번호는 8~15개의 영문 대소문자, 1개 이상의 특수문자를 반드시 포함해야 합니다."
                      class="w-full" type="password" v-model="userForm.password"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>이메일</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <vs-input :success="regExpEmail.test(userForm.email)"
                      :danger="!regExpEmail.test(userForm.email)"
                      danger-text="올바른 형식의 이메일을 입력해주세요."
                      class="w-full" type="email" v-model="userForm.email"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>취재지역</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <!-- 바이라인 [중앙신문 {지역}={기자명}기자] 의 지역. 예: 안성, 평택·안성·오산 -->
            <vs-input class="w-full" placeholder="예: 안성 (여러 곳은 · 로 구분)" v-model="userForm.region"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>입사일</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full" style="height: 48px;">
            <datepicker type="date" :disabled="entryDateDisabled" :clearable="false"
                        v-model="userForm.entryDate" lang="kr" style="width: 200px;" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>항목</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <div class="select_section">
              <v-select style="width: 100px; margin-right: 15px; display: inline-block" placeholder="부서" label="text"
                v-model="userForm.department" :clearable="false"
                :options="userModalData.optionData.departmentOption"/>
              <v-select style="width: 100px; margin-right: 15px; display: inline-block" placeholder="권한" label="text"
                v-model="userForm.level" :clearable="false"
                :options="userModalData.optionData.levelOption"/>
              <!-- 기자리스트(기사작성 화면의 '작성자'/'기타 작성자' 드롭다운) 노출 여부.
                   부서·권한과는 별개다. 미노출이어도 기사작성·수정은 가능하다.
                   새 기자는 '작성자+기타'가 기본이다. -->
              <v-select style="width: 130px; margin-right: 15px; display: inline-block" placeholder="기자리스트 노출" label="text"
                v-model="userForm.writerType" :clearable="false"
                :options="userModalData.optionData.writerTypeOption"/>
            </div>
            <div style="display: flex; justify-content: space-around; margin-top: 20px; text-align: center;">
              <div>
                메인배치권한<br>
                <md-checkbox v-model="userForm.permission.mainBatch" />
              </div>
              <div>
                배치로그열람권한<br>
                <md-checkbox v-model="userForm.permission.placeLog" />
              </div>
              <div>
                설정권한<br>
                <md-checkbox v-model="userForm.permission.setting" />
              </div>
              <div>
                배너권한<br>
                <md-checkbox v-model="userForm.permission.banner" />
              </div>
            </div>
            <div style="display: flex; justify-content: space-around; margin-top: 20px; text-align: center;">
              <div>
                부서수정권한<br>
                <md-checkbox v-model="userForm.permission.departmentEdit" />
              </div>
              <div>
                부서삭제권한<br>
                <md-checkbox v-model="userForm.permission.departmentDelete" />
              </div>
              <div>
                전체삭제권한<br>
                <md-checkbox v-model="userForm.permission.delete" />
              </div>
            </div>
            <div style="display: flex; justify-content: space-around; margin-top: 20px; text-align: center;">
              <div>
                SNS관리권한<br>
                <md-checkbox v-model="userForm.permission.sns" />
              </div>
              <div>
                승인<br>
                <md-checkbox v-model="userForm.grant" />
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto" style="margin-bottom: 60px;">
            <vs-button class="mr-3 mb-2" @click="submitUser()">{{ userModalMode === 'edit' ? '수정' : '생성' }}</vs-button>
            <vs-button
              color="warning"
              type="border"
              class="mb-2"
              @click="userModalMode === 'edit' ? editUserModalInfoCancelModalActive = true
                                              : createUserModalInfoResetModalActive = true"
            >{{ userModalMode === 'edit' ? '취소' : '초기화' }}</vs-button>
          </div>
          <div class="demo-alignment">
            <vs-popup classContent="popup-example" title="주의!!" :active.sync="createUserModalInfoResetModalActive">
              <p style="padding: 20px">작성한 정보가 모두 초기화됩니다. 계속 진행하시겠습니까?</p>

              <div style="padding:20px; display: inline-block;">
              <vs-button @click="resetUserModalData('create'); createUserModalInfoResetModalActive=false" color="primary" type="filled">예</vs-button>
              </div>
              <div style="margin-bottom: 20px; display: inline-block;">
              <vs-button @click="createUserModalInfoResetModalActive=false" color="primary" type="filled">아니오</vs-button>
              </div>

            </vs-popup>
          </div>
          <div class="demo-alignment2">
            <vs-popup classContent="popup-example2" title="수정 취소" :active.sync="editUserModalInfoCancelModalActive">
              <p style="padding: 20px">취소하시겠습니까?</p>
              <div style="padding:20px; display: inline-block;">
              <vs-button @click="resetUserModalData('edit'); editUserModalInfoCancelModalActive=false; editUserModalActive=false;" color="primary" type="filled">예</vs-button>
              </div>
              <div style="margin-bottom: 20px; display: inline-block;">
              <vs-button @click="editUserModalInfoCancelModalActive=false" color="primary" type="filled">아니오</vs-button>
              </div>
            </vs-popup>
          </div>
        </div>
      </div>
    </vs-popup>
    <!-- End: 계정 생성/수정 팝업 -->

  </div>
</template>

<script>
import moment from 'moment';
export default {
  components: {},
  data() {
    return {
      regExpName: /^[가-힣a-zA-Z0-9_ ]{2,20}$/,
      regExpAccountId: /^[a-zA-Z0-9]{6,12}$/,
      regExpPassword: /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$/,
      regExpEmail: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
      regExpHp: /^\d{3}-\d{4}-\d{4}$/,
      createUserModalActive: false,
      editUserModalActive: false,
      createUserModalInfoResetModalActive: false,
      editUserModalInfoCancelModalActive: false,
      users: [],
      currentx: 1,
      numOfUsers: 0,
      numOfPages: 0,
      searchText: "",
      userModalData: {
        createUserQueryData: {
          name: '',
          nickname: '',
          account_id: '',
          password: '',
          email: '',
          hp: '',
          tailname: '',
          region: '',
          department: "",
          level: "",
          // 기사작성 구분. 새 기자는 기본이 '작성자'다 (부서와 별개).
          writerType: { text: "작성자", value: "writer" },
          showWriterList: "",
          showStatistics: "",
          hrUser: "",
          grant: "",
          entryDate: new Date(),
          maxTimeoff: 0,
          permission: {
            mainBatch: false, placeLog: false, setting: false, banner: false,
            departmentEdit: false, departmentDelete: false, delete: false,
            sns: false,
          },
        },
        editUserQueryData: {
          name: '',
          level: '',
          // 나중에 대입만 하면 Vue 2 에서 반응하지 않는다. 여기서 선언해 둔다.
          writerType: '',
          nickname: '',
          target_account_id: '',
          account_id: '',
          password: '',
          email: '',
          hp: '',
          tailname: '',
          region: '',
          department: "",
          showWriterList: "",
          showStatistics: "",
          hrUser: "",
          grant: "",
          entryDate: new Date(),
          maxTimeoff: 0,
          profile: '',
          naverSubscribeUrl: '',
          permission: {
            mainBatch: false, placeLog: false, setting: false, banner: false,
            departmentEdit: false, departmentDelete: false, delete: false,
            sns: false,
          },
        },
        editUserQueryDataOrigin: {
          name: '',
          account_id: '',
          password: '',
          email: '',
          hp: '',
          tailname: '',
          region: '',
          department: "",
          showWriterList: "",
          showStatistics: "",
          hrUser: "",
          grant: "",
        },
        optionData: {
          levelOption: [
            { text: "데스크", value: "9" },
            { text: "일반기자", value: "8" },
            { text: "일반직원", value: "6" },
            { text: "외부기자", value: "3" },
          ],
          // 기사작성 화면의 '작성자'/'기타 작성자' 드롭다운 노출 여부.
          // 미노출(none)이면 기사작성·수정은 그대로 가능하지만 목록에는 안 뜬다.
          writerTypeOption: [
            { text: "미노출",           value: "none" },
            { text: "작성자만",         value: "writer" },
            { text: "기타 작성자만",    value: "other" },
            { text: "작성자+기타",      value: "both" },
          ],
          // 부서. member.option1 에 저장한다.
          // 🔴 목록은 **store/state.js 의 departmentOption 이 정본**이다. 여기서 복사본을
          //    들고 있다가 신설 부서가 휴가 대시보드에서 빈칸으로 나왔다(2026-09-24 정리).
          //    아래 created() 에서 스토어 값을 넣는다.
          departmentOption: [],
          showWriterListOption: [
            { text: "노출", value: "1" },
            { text: "숨김", value: "0" }
          ],
          showStatisticsOption: [
            { text: "노출", value: "1" },
            { text: "숨김", value: "0" }
          ],
          grantOption: [
            { text: "승인", value: "1" },
            { text: "거부", value: "0" }
          ]
        },
      },
      renderMethod: {
        delFrag: 1,
        level: "",
        startRow: 0,
        itemsPerPage: 15,
        factor: "name",
        inputText: ""
      },
      isMounted: false,
      files: [],
      uploadPercentage: 0,
      preview: '',
    };
  },
  beforeRouteLeave (to, from, next) {
    this.createUserModalActive = false;
    this.editUserModalActive = false;
    this.createUserModalInfoResetModalActive = false;
    this.editUserModalInfoCancelModalActive = false;
    setTimeout(() => { next(); }, 100);
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    // 생성/수정 팝업은 하나를 공유한다. 어느 쪽으로 열렸는지로 모드를 정한다.
    userModalMode() {
      return this.editUserModalActive ? 'edit' : 'create';
    },
    userModalActive: {
      get() {
        return this.createUserModalActive || this.editUserModalActive;
      },
      set(val) {
        // vs-popup 의 닫기(X)만 여기로 온다. 열기는 목록 쪽에서 각 플래그를 직접 켠다.
        if (!val) {
          this.createUserModalActive = false;
          this.editUserModalActive = false;
        }
      }
    },
    // 팝업 입력이 바인딩되는 대상. 객체 참조를 돌려주므로 v-model 이 그대로 동작한다.
    userForm() {
      return this.userModalMode === 'edit'
        ? this.userModalData.editUserQueryData
        : this.userModalData.createUserQueryData;
    },
    // 입사일은 수정 시 직원(level 5) 미만이면 잠근다. 생성 때는 항상 연다.
    entryDateDisabled() {
      if (this.userModalMode !== 'edit') return false;
      const lv = this.userModalData.editUserQueryData.level;
      return !!lv && lv.value < 5;
    }
  },
  watch: {
    '$route.query': function() {
      this.getUserList();
    },
    userModalData: function() {

      console.log(`userModalData.editUserQueryData.level: ${this.userModalData.editUserQueryData.level}`)
    }
  },
  methods: {
    changeItemPerPage(pageNum) {
      this.renderMethod.itemsPerPage = pageNum;
      this.getUserList();
    },

    factorToText(menu) {
      let menuText;
      switch (menu) {
        case "name":
          menuText = "이름";
          break;
        case "account_id":
          menuText = "아이디";
          break;
        case "email":
          menuText = "이메일";
          break;
        case "level":
          menuText = "권한";
          break;
        case "hp":
          menuText = "전화";
          break;
        case "tailname":
          menuText = "TAILNAME";
          break;
        case "grant":
          menuText = "승인";
          break;
      }
      return menuText;
    },
    deleteProfile(){
      this.userModalData.editUserQueryData.profile = '';
      this.preview = '';
    },
    isExistUser(account_id, func) {

      var thisObj = this
      
      thisObj.$http
        .post("/api/manageUsers/isExistUser", {account_id: account_id})
        .then(function(response) {
          
          console.log("exist response: "+response.data.exist)
          if(response.data.exist == "0") {
            
            func(false)
          }
          else if(response.data.exist == "1") {

            func(true)
          }
          else {

            thisObj.$vs.notify({
              title:'계정 생성 실패',
              text:"알 수 없는 오류로 인해 계정 생성에 실패했습니다.",
              color:'danger'})

            console.log("invalid data: "+response.data.exist)
          }
        })
        .catch(function(error) {
          var errorText = error.toString();
          if(errorText.includes('401')){
            alert('로그인 해주세요!')
            thisObj.$router.push({path: '/pages/login?to='+ thisObj.$router.history.current.path, query: thisObj.$router.history.current.query})
          }
          thisObj.$vs.notify({
            title: "Error",
            text: error,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle"
          });
        });
    },

    mapUserInfoAtEditModal(userInfo) {

      this.userModalData.editUserQueryData.idx = userInfo.idx
      this.userModalData.editUserQueryData.name = userInfo.name
      this.userModalData.editUserQueryData.nickname = userInfo.nickname
      this.userModalData.editUserQueryData.account_id = userInfo.id
      this.userModalData.editUserQueryData.password = ''
      this.userModalData.editUserQueryData.email = userInfo.email
      this.userModalData.editUserQueryData.hp = userInfo.hp
      this.userModalData.editUserQueryData.tailname = userInfo.tail
      // tail 은 parse() 가 빈 값을 '(없음)' 으로 바꿔 놓으므로 폴백으로 쓰면 안 된다.
      this.userModalData.editUserQueryData.region = userInfo.region || ''
      
      this.userModalData.editUserQueryData.level = this.userModalData.optionData.levelOption.find(data => data.value == userInfo.level);//userInfo.level ? userInfo.level : ""
      if(!this.userModalData.editUserQueryData.level){
        if(userInfo.level == 11){
          this.userModalData.editUserQueryData.level = { text: "최고관리자", value: "11" };
        }else if(userInfo.level == 7){
          this.userModalData.editUserQueryData.level = { text: "일반기자", value: "7" };
        }else{
          this.userModalData.editUserQueryData.level = { text: "기타", value: "0" };
        }
      }
      this.userModalData.editUserQueryData.department = this.userModalData.optionData.departmentOption.find(data => data.value == userInfo.option1);//userInfo.option1 ? userInfo.option1 : ""
      this.userModalData.editUserQueryData.writerType =
        this.userModalData.optionData.writerTypeOption.find(d => d.value == (userInfo.writer_type || 'none'))
        || this.userModalData.optionData.writerTypeOption[0];
      // this.userModalData.editUserQueryData.showWriterList = this.userModalData.optionData.showWriterListOption.find(data => data.value == userInfo.optino2);//userInfo.optino2 ? userInfo.optino2 : ""
      // this.userModalData.editUserQueryData.showStatistics = this.userModalData.optionData.showStatisticsOption.find(data => data.value == userInfo.not_involve);//userInfo.not_involve ? userInfo.not_involve : ""
      // this.userModalData.editUserQueryData.grant = this.userModalData.optionData.grantOption.find(data => data.value == userInfo.delFrag);//userInfo.delFrag ? userInfo.delFrag : ""
      
      this.userModalData.editUserQueryData.showWriterList = userInfo.optino2 == "1" ? true : false
      this.userModalData.editUserQueryData.showStatistics = userInfo.not_involve == "1" ? true : false
      this.userModalData.editUserQueryData.hrUser = userInfo.hrUser == "1" ? true : false
      this.userModalData.editUserQueryData.grant = userInfo.delFrag ? true : false

      this.userModalData.editUserQueryData.entryDate = new Date(userInfo.entry_date);
      this.userModalData.editUserQueryData.maxTimeoff = userInfo.max_timeoff;
      this.userModalData.editUserQueryData.profile = userInfo.profile;
      // 🔴 도메인을 박지 않는다. CMS 의 /news 라우트가 로컬 → CDN → 옛 사이트 순으로
      //    찾아 준다(utils/imageUrl.js 주석 참고). 예전에 cdn.jasm.co.kr 을 박아서
      //    신규 업로드가 전부 깨진 적이 있다.
      this.preview = userInfo.profile ? '/news/reporter/' + userInfo.profile : '';
      this.userModalData.editUserQueryData.naverSubscribeUrl = userInfo.naverSubscribeUrl;
      // 서버가 permission 을 안 주거나 일부 키만 주면 체크박스 렌더가 깨진다. 기본값과 병합한다.
      this.userModalData.editUserQueryData.permission = Object.assign(
        {
          mainBatch: false, placeLog: false, setting: false, banner: false,
          departmentEdit: false, departmentDelete: false, delete: false,
          sns: false,
        }, userInfo.permission || {});



      this.userModalData.editUserQueryDataOrigin.name = userInfo.name
      this.userModalData.editUserQueryDataOrigin.nickname = userInfo.nickname
      this.userModalData.editUserQueryDataOrigin.account_id = userInfo.id
      this.userModalData.editUserQueryDataOrigin.password = ''
      this.userModalData.editUserQueryDataOrigin.email = userInfo.email
      this.userModalData.editUserQueryDataOrigin.hp = userInfo.hp
      this.userModalData.editUserQueryDataOrigin.tailname = userInfo.tail
      this.userModalData.editUserQueryDataOrigin.region = userInfo.region || ''
      
      this.userModalData.editUserQueryDataOrigin.level = this.userModalData.optionData.levelOption.find(data => data.value == userInfo.level);//userInfo.level ? userInfo.level : ""
      this.userModalData.editUserQueryDataOrigin.department = this.userModalData.optionData.departmentOption.find(data => data.value == userInfo.option1);//userInfo.option1 ? userInfo.option1 : ""
      // this.userModalData.editUserQueryDataOrigin.showWriterList = this.userModalData.optionData.showWriterListOption.find(data => data.value == userInfo.optino2);//userInfo.optino2 ? userInfo.optino2 : ""
      // this.userModalData.editUserQueryDataOrigin.showStatistics = this.userModalData.optionData.showStatisticsOption.find(data => data.value == userInfo.not_involve);//userInfo.not_involve ? userInfo.not_involve : ""
      // this.userModalData.editUserQueryDataOrigin.grant = this.userModalData.optionData.grantOption.find(data => data.value == userInfo.delFrag);//userInfo.delFrag ? userInfo.delFrag : ""
    },

    showUserInfo(account_id) {

      var thisObj = this;

      thisObj.$http
          .post("/api/manageUsers/getReporter", {account_id: account_id})
          .then(function(response) {

            console.log("getReporter: ", response.data)
            thisObj.mapUserInfoAtEditModal(response.data)
            thisObj.editUserModalActive = true
          })
          .catch(function(error) {
            var errorText = error.toString();
            if(errorText.includes('401')){
              alert('로그인 해주세요!')
              console.log(thisObj.$router)
              thisObj.$router.push({path: '/pages/login?to='+ thisObj.$router.history.current.path, query: thisObj.$router.history.current.query})
            }
            thisObj.$vs.notify({
              title: "Error",
              text: error,
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle"
            });
          });
    },

    // ---- 계정 생성/수정 공통 ----
    // 두 흐름은 '검증 → 아이디 중복확인 → v-select 평탄화 → POST → 알림·초기화' 로 같다.
    // 다른 것은 네 가지뿐이라 userModalMode 로 갈랐다.
    //   1) 수정은 아이디를 바꿨을 때만 중복확인한다
    //   2) 비밀번호는 수정 때 비워두면 그대로 둔다는 뜻이라 검사에서 뺀다
    //   3) 엔드포인트와 문구
    //   4) writer_type 기본값 — 새 기자는 '작성자+기타' 노출

    submitUser() {

      var thisObj = this
      var isEdit = thisObj.userModalMode === 'edit'

      if(!thisObj.isPassedIntegrityVerification(isEdit ? "edit_user" : "create_user")) {
        return;
      }

      var accountId = thisObj.userForm.account_id
      var idChanged = !isEdit
        || thisObj.userModalData.editUserQueryDataOrigin.account_id != accountId

      if(!idChanged) {
        thisObj.runSubmitUser()
        return
      }

      thisObj.isExistUser(accountId, function(exist) {

        if(exist) {

          thisObj.$vs.notify({
            title:'중복 아이디',
            text:"중복된 아이디입니다.",
            color:'warning'})

          return
        }

        thisObj.runSubmitUser()
      })
    },

    runSubmitUser() {

      var thisObj = this
      var mode = thisObj.userModalMode
      var isEdit = mode === 'edit'
      var form = thisObj.userForm

      if(isEdit) {
        form.target_account_id = thisObj.userModalData.editUserQueryDataOrigin.account_id
      }

      // v-select 는 {text, value} 객체를 담는다. 서버에는 value 만 보낸다.
      form.department = form.department ? form.department.value : ''
      form.level = form.level ? form.level.value : ''
      form.writer_type = form.writerType ? form.writerType.value : (isEdit ? 'none' : 'both')
      form.entryDate = form.entryDate ? moment(form.entryDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      form.maxTimeoff = form.maxTimeoff ? form.maxTimeoff : 0
      form.permission = form.permission ? form.permission : {}

      var url = isEdit ? "/api/manageUsers/editReporter" : "/api/manageUsers/createReporter"
      var label = isEdit ? '수정' : '생성'
      // 수정은 아이디를 바꿨을 수 있으니 바뀌기 전 아이디로 알린다.
      var who = isEdit ? thisObj.userModalData.editUserQueryDataOrigin.account_id : form.name

      thisObj.$http
          .post(url, form)
          .then(function(response) {

            if(response.data === "success") {
              thisObj.$store.dispatch('EditWriterList', {writer: form});
              thisObj.$vs.notify({
                title:'계정 ' + label + ' 완료',
                text:"계정 '" + who + "' " + label + " 완료.",
                color:'success'})

              // 닫으면 userModalMode 가 create 로 돌아가므로 초기화를 먼저 한다.
              thisObj.resetUserModalData(mode)
              thisObj.userModalActive = false
              thisObj.getUserList()
            }
            else {

              console.log('response) ', response)

              thisObj.$vs.notify({
                title:'계정 ' + label + ' 실패',
                text:"계정 '" + who + "' " + label + " 실패.",
                color:'danger'})
            }

            thisObj.$vs.loading.close("#button-with-loading > .con-vs-loading");
          })
          .catch(function(error) {
            var errorText = error.toString();
            if(errorText.includes('401')){
              alert('로그인 해주세요!')
              thisObj.$router.push({path: '/pages/login?to='+ thisObj.$router.history.current.path, query: thisObj.$router.history.current.query})
            }
            thisObj.$vs.notify({
              title: "Error",
              text: error,
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle"
            });
          });
    },

    // mode 를 넘기지 않으면 지금 열려 있는 팝업 쪽을 비운다.
    resetUserModalData(mode) {

      var isEdit = (mode || this.userModalMode) === 'edit'
      var q = isEdit ? this.userModalData.editUserQueryData
                     : this.userModalData.createUserQueryData

      var blanks = ['name', 'nickname', 'account_id', 'password', 'email', 'hp',
                    'tailname', 'region', 'department', 'level',
                    'showWriterList', 'showStatistics', 'grant']
      blanks.forEach(function(k) { q[k] = '' })

      q.entryDate = new Date()
      q.maxTimeoff = 0
      // 새 기자의 기본은 '작성자+기타' 노출이다. 수정 폼은 열 때 값을 다시 채우므로 비워 둔다.
      q.writerType = isEdit
        ? ''
        : this.userModalData.optionData.writerTypeOption.find(function(d) { return d.value === 'both' })
      q.permission = {
        mainBatch: false, placeLog: false, setting: false, banner: false,
        departmentEdit: false, departmentDelete: false, delete: false,
        sns: false,
      }
    },

    isPassedIntegrityVerification(type) {

      var isEdit = type === "edit_user"
      if(!isEdit && type !== "create_user") {
        return false
      }

      var q = isEdit ? this.userModalData.editUserQueryData
                     : this.userModalData.createUserQueryData
      var origin = this.userModalData.editUserQueryDataOrigin

      // 생성은 전 항목, 수정은 바뀐 항목만 본다.
      // level·department 는 optionOption 배열의 같은 객체를 참조하므로 !== 로 비교된다.
      var touched = function(field) { return !isEdit || q[field] !== origin[field] }
      var filled = function(field) { return !touched(field) || !!(q[field] && q[field] !== '') }

      var fillDataCheck = filled('name') && filled('account_id') && filled('email')
              && filled('department') && filled('level')
              // 수정은 비밀번호를 비워두면 그대로 둔다는 뜻이다.
              && (isEdit || filled('password'))

      var nameCheck      = !touched('name')       || this.regExpName.test(q.name)
      var accountIdCheck = !touched('account_id') || this.regExpAccountId.test(q.account_id)
      var passwordCheck  = !touched('password')   || this.regExpPassword.test(q.password)
      var emailCheck     = !touched('email')      || this.regExpEmail.test(q.email)

      if(!fillDataCheck) {

        this.$vs.notify({
          title:'미입력',
          text:"빠짐없이 입력 하세요.",
          color:'warning'})

        return false;
      }

      if(!nameCheck) {

        this.$vs.notify({
          title:'이름',
          text:"완전한한글, 영문, 숫자, _로 2~20글자 입력해야 하며, 특수문자를 입력할 수 없습니다.",
          color:'warning'})
      }
      if(!accountIdCheck) {

        this.$vs.notify({
          title:'아이디',
          text:"아이디는 6~12글자, 공백 및 특수문자를 포함할 수 없습니다.",
          color:'warning'})
      }
      if(!passwordCheck) {

        this.$vs.notify({
          title:'비밀번호',
          text:"비밀번호는 8~15개의 영문 대소문자, 1개 이상의 특수문자를 반드시 포함해야 합니다.",
          color:'warning'})
      }
      if(!emailCheck) {

        this.$vs.notify({
          title:'이메일',
          text:"올바른 형식의 이메일을 입력해주세요.",
          color:'warning'})
      }

      return nameCheck && accountIdCheck && passwordCheck && emailCheck
    },

    searchUserList() {
      this.resetPagePosition()
      this.updateSearchText()
      this.getUserList()
    },

    getUserList() {
      this.$vs.loading({
        container: "#button-with-loading",
        scale: 0.6
      });
      const thisIns = this;

      if(this.$route.query.deleted){
        this.renderMethod.delFrag = 0;
      }else{
        this.renderMethod.delFrag = 1;
      }
      if(this.$route.query.department){
        this.renderMethod.department = this.$route.query.department;
      }else{
        this.renderMethod.department = null;
      }
      this.$http
        .post("/api/manageUsers/reporterlist", this.buildSearchParam())
        .then(function(response) {
          thisIns.numOfUsers = response.data[0][0].user_count;
          thisIns.numOfPages = parseInt(
            response.data[0][0].user_count / thisIns.renderMethod.itemsPerPage
          );
          thisIns.users = response.data[1];

          thisIns.$vs.loading.close("#button-with-loading > .con-vs-loading");
        })
        .catch(function(error) {
          var errorText = error.toString();
          if(errorText.includes('401')){
            alert('로그인 해주세요!')
            thisIns.$router.push({path: '/pages/login?to='+ thisIns.$router.history.current.path, query: thisIns.$router.history.current.query})
          }
          thisIns.$vs.notify({
            title: "Error",
            text: error,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle"
          });
        });
    },

    buildSearchParam() {

      var param = {};
      param.delFrag = this.renderMethod.delFrag;
      param.department = this.renderMethod.department;
      param['level'] = this.renderMethod.level
      param['startRow'] = this.renderMethod.startRow
      param['itemsPerPage'] = this.renderMethod.itemsPerPage
      param['factor'] = this.renderMethod.factor
      param['searchText'] = this.searchText

      return param
    },

    addFile(e){
      // console.log(e.target.files, e.target.files[0]);
      if(e.target.files.length ){
        this.files[0] = e.target.files[0];
        this.submitFiles(e.target.files);
      }
    },
    /*
      Determines if the drag and drop functionality is in the
      window
    */
    determineDragAndDropCapable(){
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div');

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData` and `FileReader` objects
        present so we can do our AJAX uploading
      */
      return ( ( 'draggable' in div )
              || ( 'ondragstart' in div && 'ondrop' in div ) )
              && 'FormData' in window
              && 'FileReader' in window;
    },

    /*
      Submits the files to the server
    */
    submitFiles(files){
      /*
        Initialize the form data
      */
      let formData = new FormData();
      let thisIns = this;

      /*
        Iteate over any file sent over appending the files
        to the form data.
      */
      for( var i = 0; i < files.length; i++ ){
        let file = files[i];
        formData.append('file', file);
      }
      formData.append('type', 12);
      formData.append('partName', thisIns.userModalData.editUserQueryData.idx);
      /*
        Make the request to the POST /file-drag-drop-instant URL
      */
      let targetUrl = '/api/fileUpload';
      this.$http.post( targetUrl,
        formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function( progressEvent ) {
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
          }.bind(this)
        }
      ).then(function(response){
        console.log('SUCCESS!!', response);
        if(response.data.length){
            thisIns.userModalData.editUserQueryData.profile = response.data[0];
            thisIns.preview = "/api/photo/viewImages?filename=" + response.data[0];
        }
        // thisIns.getImagePreviews();
      })
      .catch(function(response){
        console.log('FAILURE!!', response);
      });
    },

    resetPagePosition() {
      this.currentx = 1;
      this.renderMethod.startRow = 0;
    },

    updateSearchText() {
      this.searchText = this.renderMethod.inputText
    },
    showSidebar() {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
  },
  created() {
    // 부서 목록은 스토어가 정본이다(store/state.js departmentOption).
    // 복사본을 두면 부서를 늘릴 때 한쪽만 고쳐져 빈칸이 생긴다.
    this.userModalData.optionData.departmentOption = this.$store.state.departmentOption;

    if(this.$store.state.AppActiveUser.level >= 10) {
      
      this.userModalData.optionData.levelOption.push({ text: "관리자", value: "10" })
    }
    
    const thisIns = this;

    if(this.$route.query.deleted){
      this.renderMethod.delFrag = 0;
    }
    if(this.$route.query.department){
      this.renderMethod.department = this.$route.query.department;
    }else{
      this.renderMethod.department = null;
    }

    this.$http
      .post("/api/manageUsers/reporterlist", thisIns.renderMethod)
      .then(function(response) {
        thisIns.numOfUsers = response.data[0][0].user_count;
        thisIns.numOfPages = parseInt(
          response.data[0][0].user_count / thisIns.renderMethod.itemsPerPage
        );
        thisIns.users = response.data[1];
      })
      .catch(function(error) {
        var errorText = error.toString();
        if(errorText.includes('401')){
          alert('로그인 해주세요!')
          console.log(thisIns.$router)
          thisIns.$router.push({path: '/pages/login?to='+ thisIns.$router.history.current.path, query: thisIns.$router.history.current.query})
        }
        thisIns.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      });
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
</style>
<style lang="scss">
@import "@/assets/scss/custom-style/vs-table-reporter.scss";
</style>
